<template>
  <div class="diantao-liveroom">
    <el-row :gutter="16" type="flex">
      <el-col :span="4">
        <el-input v-model="crawlerVersion" clearable placeholder="输入采集日期"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="crawlerVersionHour" clearable placeholder="输入采集小时"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="keyword" clearable placeholder="输入检索词"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button icon="el-icon-search" @click="searchPageData">搜索</el-button>
        <!--        <el-button icon="el-icon-download" @click="exportSelectedData" alt="">下载(带货架商品)</el-button>-->
        <el-button icon="el-icon-download" @click="exportSelectedJustLiveRooms" alt>下载(仅直播间)</el-button>
      </el-col>
    </el-row>

    <el-row style="padding-top: 16px">
      <el-pagination
        background
        @current-change="queryGoodsPage"
        layout="total, prev, pager, next"
        :total="totalItems"
        :page-size="pageSize"
      ></el-pagination>
    </el-row>
    <el-row style="padding-top: 16px">
      <el-table
        :data="liveRooms"
        style="width: 100%"
        @select="handleSelectionChange"
        @select-all="handleSelectAll"
        @scroll="tableScroll"
        :key="itemKey"
        ref="dataTable"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="searchKeyword" label="日期/小时/关键词">
          <template
            slot-scope="scope"
          >{{ scope.row.crawlerVersion }}/{{ scope.row.crawlerVersionHour }}/{{ scope.row.searchKeyword }}</template>
        </el-table-column>
        <el-table-column prop="_id" label="主键"></el-table-column>
        <el-table-column prop="authorDouId" label="直播间信息">
          <template slot-scope="scope">
            房间ID:{{ scope.row.roomId }}
            <el-tooltip
              class="item"
              effect="dark"
              content="点击前往货架"
              placement="top"
              v-if="scope.row.canJump"
            >
              <el-tag
                size="mini"
                type
                effect="dark"
                style="margin-left: 5px;cursor:pointer"
                @click="goGoodsShevles(scope.row.roomId)"
              >
                <a class="el-icon-right" alt="点击前往货架"></a>
              </el-tag>
            </el-tooltip>
            <br />
            直播间标题:{{ scope.row.roomTitle }}
            <br />
            直播地址:{{ scope.row.roomLink }}
            <br />
            开播时间 {{ scope.row.roomCreateTimeStr}}
            <br />
          </template>
        </el-table-column>
        <el-table-column prop="isExist" label="是否校验" align="center">
          <template slot-scope="scope">
            <span
              :style="scope.row.isExist==='1'?'color:red':''"
            >{{ scope.row.isExist==='1'?'是':'否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="主播信息">
          <template slot-scope="scope">
            UID:{{ scope.row.userid }}
            <br />
            昵称:{{ scope.row.userName }}
            <br />
            企业认证:{{scope.row.userEnterpriseVerifyReason}}
            <br />
            粉丝数:{{scope.row.userFansCount}}
            <br />
            关注数:{{scope.row.userFollowCount}}
            <br />
            <a target="blank" :href="scope.row.userPcProfileLink">个人主页</a>
            <br />
          </template>
        </el-table-column>
        <el-table-column prop="authorDouId" label="店铺信息">
          <template slot-scope="scope">
            shopId: {{ scope.row.shopid }}
            <br />
            店铺名称:{{ scope.row.shopName }}
            <br />
            店铺链接:{{scope.row.shopLink}}
            <br />
          </template>
        </el-table-column>
        <el-table-column label="主播头像" width="100">
          <template slot-scope="scope">
            <img :src="scope.row.userAvatar" width="70" height="70" class="head_pic" />
          </template>
        </el-table-column>
        <el-table-column label="备注" width="100">
          <template slot-scope="scope">
            <p v-if="!scope.row.isEditor" class="node-text">{{ scope.row.remark }}</p>
            <div class="list-node" v-if="scope.row.isEditor">
              <el-input
                @blur="blurNode(scope.row)"
                type="textarea"
                :rows="2"
                placeholder="请输入备注"
                v-focus
                v-model="remark"
              ></el-input>
            </div>
            <span
              v-if="scope.row.isEditor"
              :class="
                      'el-icon-circle-check change-icon'
                    "
              @click="handleTableChange(scope.row)"
            ></span>
            <span
              :class="
                      scope.row.isEditor
                        ? 'el-icon-circle-close' + ' change-icon'
                        : 'el-icon-edit' + ' change-icon'
                    "
              @click="changeNodeMethod(scope.row)"
            ></span>
            <!-- <div
              v-if="!scope.row.isEditor"
              @click="getInput(scope.row)"
            >{{ scope.row.remark||'N/A' }}</div>
            <div v-else>
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.remark"></el-input>
              <el-button @click="editorRemark(scope.row.roomId,scope.row.remark)">确认</el-button>
            </div>-->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
const axios = require("axios");
// const _ = require("lodash");
const focus = {
  inserted: el => {
    console.log(el.children[0], "el");
    el.children[0].focus();
  }
};
export default {
  directives: {
    focus
  },
  name: "diantaoLiveRooms",
  data() {
    return {
      liveRooms: [],
      keyword: "",
      authorNickname: "",
      authorDouId: "",
      whether: null,
      videoTitle: "",
      crawlerVersion: null,
      crawlerVersionHour: null,
      currentPage: 1,
      totalItems: 0,
      pageSize: 50,
      selectedCount: 0,
      itemKey: 0,
      memoScroll: 0,
      memoScrollLeft: 0,
      remark: ""
    };
  },
  computed: {
    elTable: function() {
      return document.getElementsByClassName("diantao-liveroom")[0];
    },
    leftelTable() {
      return this.$refs["dataTable"].$el.querySelector(
        "div.el-table__body-wrapper"
      );
    }
  },
  methods: {
    // 店铺状态编辑
    handleTableChange(row) {
      let param = {
        userId: row.userid,
        remark: this.remark
      };
      //修改
      axios.post("/api/diantao/addLiveRoomRemark", param).then(content => {
        console.log(content);
        if (content.data.status.code === "0") {
          this.$message({
            type: "success",
            message: content.data.status.message
          });
        }
      });
      row.isEditor = false;
      // this.itemKey++;
      // this.memoScroll = this.elTable.scrollTop;

      this.$nextTick(() => {
        this.liveRooms.forEach((el, index) => {
        if (el._id === row._id) {
          console.log(el,'一样的');
          let obj = {...el}
          obj.remark=this.remark
          this.$set(this.liveRooms, index, obj);
        }
        // this.$refs["dataTable"].doLayout();
      });
    })
    },
    blurNode(key) {
      setTimeout(() => {
        key.isEditor = false;
        this.refreshTable();

        this.$nextTick(() => {
          // this.$refs["dataTable"].doLayout();
        });
      }, 250);
    },
    refreshTable() {
      const scrollTop = this.$refs.dataTable.scrollTop;
      console.log(this.$refs.dataTable.scrollTop, "beforeScrollTop");
      // this.itemKey = Math.random();
      setTimeout(() => {
        this.$refs.dataTable.scrollTop = scrollTop;
      }, 10);
    },
    changeNodeMethod(val) {
      this.remark=''
      val.isEditor = !val.isEditor;
      

      this.refreshTable();

      this.$nextTick(() => {
        this.liveRooms.forEach((el, index) => {
        if (el._id === val._id) {
          let obj = {...el}
          obj.isEditor=val.isEditor
          this.$set(this.liveRooms, index, obj);
        }
      });
        this.$forceUpdate();

        this.$refs["dataTable"].doLayout();
        
      });
    },
    tableScroll() {
      // this.$refs['dataTable'].$el.querySelector('div.el-table__body-wrapper').scrollTop
      // this.scrollLeft = event.target.scrollLeft;
    },

    goGoodsShevles(key) {
      console.log(key);
      window.open(
        this.$router.resolve({ name: "diantaoLiveShevles", query: { id: key } })
          .href,
        "_blank"
      );
    },
    handleSelectAll() {},
    handleSelectionChange() {},
    exportSelectedData() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=1";

      window.open("/api/diantao/export/liverooms?" + para);
    },
    exportSelectedJustLiveRooms() {
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }
      para += "&withGoods=0";

      window.open("/api/diantao/export/liverooms?" + para);
    },
    searchPageData() {
      this.currentPage = 1;
      this.loadItemInfo(1);
    },
    queryGoodsPage(pageNum) {
      this.currentPage = pageNum;
      this.loadItemInfo(pageNum);
    },
    loadItemInfo(pageNum) {
      var _this = this;
      let para = "";
      if (this.crawlerVersion != null && this.crawlerVersion != "") {
        para += "&crawlerVersion=" + this.crawlerVersion;
      }

      if (this.crawlerVersionHour != null && this.crawlerVersionHour != "") {
        para += "&crawlerVersionHour=" + this.crawlerVersionHour;
      }

      if (this.keyword !== "") {
        para += "&keyword=" + this.keyword;
      }

      axios
        .get(
          "/api/diantao/queryPageLiveRooms?page=" +
            pageNum +
            "&pageSize=50" +
            para
        )
        .then(content => {
          if (content.data.status.code === 0) {
            console.log(content.data.data);
            _this.liveRooms = content.data.data.liveRooms;
            _this.liveRooms.map(val => {
              val.isEditor = false;
              return val;
            });
            _this.totalItems = content.data.data.total;
          }
        });
    }
  },
  mounted() {
    this.loadItemInfo(1);
  }
};
</script>
<style scoped>
.change-icon {
  color: #4772ff;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
</style>
